// @owners { team: patients }
import { useNavigation } from '@alto/navigation';
import { Platform } from 'react-native';

export function useNavigateAfterVerification(authorized: boolean) {
  const { navigate } = useNavigation();

  const navigateToNextRoute = () => {
    if (authorized) {
      navigate('RouteAppTabNavigator', { screen: 'RouteTabMyMeds' });
    } else {
      if (Platform.OS === 'web') {
        navigate('RouteLogin');
      } else {
        navigate('RouteWelcome');
      }
    }
  };

  return navigateToNextRoute;
}
